import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取空运港口列表
export function getSiJobDetail(uuid) {
  return request({
    url: URL.booking.seaImport.siDetail,
    method: 'get',
    params: { uuid }
  })
}
